import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/crm/projects')({
  component: () => <PageStub title="Projects" description="Project management and tracking" />,
});
